import {
  MAX_POLL_DURATION_MS,
  PHASE_1_FRAC,
  PHASE_1_TARGET_PCT,
  PHASE_2_FRAC,
  PHASE_2_TARGET_PCT,
  PHASE_3_FRAC,
  PHASE_3_TARGET_PCT,
  PHASE_4_TARGET_PCT,
} from "../lib/constants";
import useProgressBar from "../hooks/useProgressBar";
import ToastShell from "./ToastShell";

/**
 * Loading toast with a phased progress bar whose boundaries scale with the
 * max timeout so it feels responsive regardless of how long the action takes.
 *
 * Phases (as fractions of maxSeconds):
 *   0 – 50%   → rapid fill from 0% to 75%
 *   50 – 65%  → hold at 75%
 *   65 – 85%  → creep from 75% to 85%
 *   85 – 100% → creep from 85% to 90%
 *   on completion (t.completed) → jump to 100%
 */
const computeProgress = (elapsed, maxSeconds) => {
  const p1End = maxSeconds * PHASE_1_FRAC;
  const p2End = maxSeconds * PHASE_2_FRAC;
  const p3End = maxSeconds * PHASE_3_FRAC;

  if (elapsed <= p1End) {
    return PHASE_1_TARGET_PCT * (elapsed / p1End);
  } else if (elapsed <= p2End) {
    return PHASE_2_TARGET_PCT;
  } else if (elapsed <= p3End) {
    const fraction = (elapsed - p2End) / (p3End - p2End);
    return PHASE_2_TARGET_PCT + (PHASE_3_TARGET_PCT - PHASE_2_TARGET_PCT) * Math.min(fraction, 1);
  } else if (elapsed <= maxSeconds) {
    const fraction = (elapsed - p3End) / (maxSeconds - p3End);
    return PHASE_3_TARGET_PCT + (PHASE_4_TARGET_PCT - PHASE_3_TARGET_PCT) * Math.min(fraction, 1);
  }
  return PHASE_4_TARGET_PCT;
};

const PolicyActionToast = ({ t }) => {
  const maxSeconds = (t.progressDuration ?? MAX_POLL_DURATION_MS) / 1000;
  const progress = useProgressBar(t.completed, (elapsed) =>
    computeProgress(elapsed, maxSeconds)
  );

  return <ToastShell t={t} progress={progress} />;
};

export default PolicyActionToast;
